<template>
  <div class="container">
    <p class="content">
      {{ lineUserName }} 您好，在開始使用牙醫小幫手前，需要請您先詳細閱讀並同意服務條款。
    </p>
    <div class="field">
      <div class="control">
        <button class="button is-primary is-outlined" @click="termModalActive = true">
          點此閱讀使用者條款
        </button>
      </div>
    </div>
    <div class="field">
      <label class="checkbox">
        <input v-model="isAgree" type="checkbox">
        我已詳細閱讀並同意使用者條款
      </label>
    </div>
    <div v-if="hasNameField" class="field">
      <label class="label">姓名</label>
      <div class="control">
        <input
          v-model="name"
          type="text"
          class="input"
          :class="{ 'is-danger': showNameHelpText }"
        />
      </div>
      <p v-show="showNameHelpText" class="help is-danger">
        請填寫姓名
      </p>
    </div>
    <div class="field">
      <label class="label">手機</label>
      <div class="control">
        <div class="field is-grouped">
          <div class="control phone">
            <input
              v-model="phone"
              type="text"
              class="input"
              :class="{ 'is-danger': showPhoneHelpText }"
            />
          </div>
          <div class="control code">
            <button
              class="button is-primary is-outlined is-rounded"
              :class="{ 'is-loading': isSendingCode }"
              :disabled="!isAgree || !phone"
              @click="getVerificationCode"
            >
              發送驗證碼
            </button>
          </div>
        </div>
      </div>
      <p v-show="showPhoneHelpText" class="help is-danger">
        {{ phoneMessage }}
      </p>
    </div>
    <div class="field">
      <label class="label">簡訊驗證碼</label>
      <div class="control">
        <input
          v-model="verificationCode"
          type="text"
          class="input"
          :class="{ 'is-danger': showCodeHelpText }"
        />
      </div>
      <p v-show="showCodeHelpText" class="help is-danger">
        請填寫驗證碼
      </p>
    </div>
    <div class="field">
      <label class="label">姓名</label>
      <div class="control">
        <input
          v-model="user_name"
          type="text"
          class="input"
        />
      </div>
    </div>
    <div class="field">
      <label class="label">Email</label>
      <div class="control">
        <input
          v-model="user_email"
          type="text"
          class="input"
        />
      </div>
    </div>
    <div class="field submit">
      <div class="control">
        <button
          class="button is-primary is-fullwidth"
          :class="{ 'is-loading': isSubmitting }"
          :disabled="!isAgree || !verificationCode"
          @click="submit"
        >
          確認送出
        </button>
      </div>
    </div>
    <TermModal :isActive="termModalActive" @close="closeTermModal" />
  </div>
</template>

<script>
import TermModal from '@/components/TermModal.vue';

export default {
  name: 'SignupForm',
  components: {
    TermModal,
  },
  props: {
    lineUserName: {
      type: String,
      default: '',
    },
    hasNameField: {
      type: Boolean,
      default: false,
    },
    defaultPhone: String,
    defaultAgree: Boolean,
    sendVerificationCode: Function,
    submitVerificationCode: Function,
    isSendingCode: Boolean,
    isSubmitting: Boolean,
  },
  data() {
    return {
      isAgree: this.defaultAgree,
      name: '',
      phone: this.defaultPhone,
      user_name: '',
      user_email: '',
      verificationCode: '',
      showNameHelpText: false,
      showPhoneHelpText: false,
      showCodeHelpText: false,
      phoneMessage: '請填寫手機號碼',
      termModalActive: false,
    };
  },
  watch: {
    defaultAgree(val) {
      this.isAgree = val;
    },
    defaultPhone(val) {
      this.phone = val;
    },
    phone(val) {
      this.showPhoneHelpText = false;
      if (!this.isValidPhone(val.trim())) {
        this.phoneMessage = '請輸入正確的手機格式';
        this.showPhoneHelpText = true;
      }
    },
    name(val) {
      this.showNameHelpText = !val;
    },
    verificationCode(val) {
      this.showCodeHelpText = !val;
    },
  },
  methods: {
    getFormData(obj) {
      const formData = new FormData();
      Object.entries(obj).forEach(([key, val]) => {
        formData.append(key, val);
      });
      return formData;
    },
    closeTermModal() {
      this.termModalActive = false;
    },
    isValidPhone(phone) {
      const phonePatt = /^09[0-9]{8}$/;
      if (phonePatt.test(phone.trim())) {
        return true;
      }
      return false;
    },
    async getVerificationCode() {
      if (this.showPhoneHelpText || !this.phone) {
        this.showPhoneHelpText = true;
        return;
      }
      if (this.hasNameField && !this.name) {
        this.showNameHelpText = true;
        return;
      }
      this.sendVerificationCode(this.phone, this.hasNameField ? this.name : this.lineUserName);
    },
    submit() {
      this.showCodeHelpText = !this.verificationCode;
      if (!this.verificationCode || !this.isAgree) {
        return;
      }
      this.submitVerificationCode(this.verificationCode, this.user_name, this.user_email);
    },
  },
};
</script>

<style scoped>
.field:not(:last-child) {
  margin-bottom: 1.0rem;
}
</style>
<style>
.field.submit {
  margin-top: 2.0rem;
}
.control.phone {
  max-width: 60%;
}
.control.code {
  display: flex;
  align-items: center;
}
</style>
